const c = {
  name: "Gateway",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23.9,24.4c-0.9-1.2-2.3-1.9-3.9-1.9c-1.6,0-3,0.8-3.9,1.9l-6.3-3.1C9.9,20.9,10,20.4,10,20
			c0-0.4-0.1-0.9-0.2-1.3l6.3-3.1c0.9,1.2,2.3,1.9,3.9,1.9c1.6,0,3-0.8,3.9-1.9l6.3,3.1C30.1,19.1,30,19.5,30,20
			c0,0.5,0.1,0.9,0.2,1.3L23.9,24.4z M20,30.5c-1.7,0-3-1.4-3-3s1.3-3,3-3c1.6,0,3,1.4,3,3S21.7,30.5,20,30.5z M5,23
			c-1.7,0-3-1.4-3-3s1.3-3,3-3s3,1.4,3,3S6.7,23,5,23z M20,9.5c1.6,0,3,1.3,3,3s-1.4,3-3,3c-1.7,0-3-1.3-3-3S18.4,9.5,20,9.5z
			 M35,17c1.7,0,3,1.4,3,3s-1.3,3-3,3c-1.6,0-3-1.4-3-3S33.4,17,35,17z M35,32c1.7,0,3,1.3,3,3s-1.3,3-3,3c-1.6,0-3-1.3-3-3
			S33.4,32,35,32z M35,2c1.7,0,3,1.3,3,3s-1.3,3-3,3c-1.6,0-3-1.4-3-3S33.4,2,35,2z M35,25c2.8,0,5-2.2,5-5s-2.2-5-5-5
			c-1.6,0-3,0.8-3.9,1.9l-6.3-3.1c0.1-0.4,0.2-0.8,0.2-1.3c0-0.4-0.1-0.9-0.2-1.3l6.3-3.1C32,9.2,33.4,10,35,10c2.8,0,5-2.2,5-5
			s-2.2-5-5-5c-2.8,0-5,2.2-5,5c0,0.4,0.1,0.9,0.2,1.3l-6.3,3.1C23,8.3,21.6,7.5,20,7.5c-2.8,0-5,2.2-5,5c0,0.5,0.1,0.9,0.2,1.3
			l-6.3,3.1C8,15.8,6.6,15,5,15c-2.8,0-5,2.2-5,5s2.2,5,5,5c1.6,0,3-0.8,3.9-1.9l6.3,3.1C15.1,26.6,15,27,15,27.5c0,2.8,2.2,5,5,5
			c1.6,0,3-0.8,3.9-1.9l6.3,3.1C30.1,34.1,30,34.5,30,35c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5c0-2.8-2.2-5-5-5c-1.6,0-3,0.8-3.9,1.9
			l-6.3-3.1c0.1-0.4,0.2-0.8,0.2-1.3c0-0.4-0.1-0.9-0.2-1.3l6.3-3.1C32,24.2,33.4,25,35,25z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Gateway
};
